<template>
  <div class="form-wrapper">
    <v-form v-model="isVerified">
      <v-text-field
        v-model="name"
        autofocus
        :rules="[v => !!v || 'Please set a name!']"
        persistent-hint
        hint="Chapter Name"
        :loading="isLoading"
        solo
        flat
        label="Choose a descriptive chapter name"
        @keypress.stop.exact.enter="createChapter"
      />
    </v-form>
    <v-spacer />
    <div class="actions layout mt-4 justify-end">
      <core-button secondary class="mr-3" not-rounded flat label="Cancel" @click.stop="close" />
      <core-button
        :is-loading="isLoading"
        :disabled="!isVerified"
        not-rounded
        flat
        label="Create chapter"
        @click.stop="createChapter"
      />
    </div>
  </div>
</template>

<script>
import CoreButtonVue from '../../../buttons/CoreButton.vue';
import { CREATE_CHAPTER } from '../../../../../config/constants';
import { EventBus } from '../../../../../event-bus';
import { changeQuery } from '../../../../../router';
export default {
  name: 'CreateChapterDialog',
  components: {
    coreButton: CoreButtonVue
  },
  data() {
    return {
      name: null,
      isVerified: false,
      isLoading: false
    };
  },
  methods: {
    close() {
      changeQuery({ dialog: false });
    },
    createChapter() {
      if (this.isVerified) {
        this.isLoading = true;
        this.$store
          .dispatch(CREATE_CHAPTER, { name: this.name })
          .then(async slide => {
            await this.$store.dispatch('alerts/success', 'Created chapter: ' + this.name);
            this.close();
            this.name = null;
            EventBus.$emit('reload-presentations', true);
          })
          .catch(err => {})
          .finally(() => (this.isLoading = false));
      }
    }
  }
};
</script>

<style scoped>
.form-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
